import { NavLink } from 'react-router-dom';

import { Add16 } from '@ingrid/iconography/react';
import { Breadcrumb, Button, InteractiveTable, PageTitle, PageWrapper } from '@ingrid/luterkort-react';

import { RoleGuard } from '~src/components/RoleGuard/RoleGuard';
import { useTranslation } from '~src/i18n/use-translation';
import { AppRoute } from '~src/main/routes';

import { useFilteredShipmentTemplateList } from '../queries';
import { Filters } from './filters/filters';
import { ListTable } from './list-table';

export function Page() {
  const { data, filtered, isFetched, isFetching } = useFilteredShipmentTemplateList();
  const { t } = useTranslation();

  return (
    <InteractiveTable.Provider allowHighlight keepInactive>
      <PageWrapper>
        <PageTitle.Wrapper>
          <PageTitle.Stack>
            <Breadcrumb aria-label={t('common.breadcrumbs')}>
              <NavLink to="..">{t('common.settings')}</NavLink>
              <a aria-current="page">{t('common.shipmentTemplates')}</a>
            </Breadcrumb>
          </PageTitle.Stack>
          <RoleGuard roles={['transport:edit']} withTooltip>
            <Button as={NavLink} to={AppRoute.CREATE}>
              <Add16 />
              {t('common.addTemplate')}
            </Button>
          </RoleGuard>
        </PageTitle.Wrapper>

        <Filters />

        <section style={{ backgroundColor: 'inherit' }}>
          <ListTable
            isEmpty={isFetched && filtered.length === 0}
            shipmentTemplatesWithTags={filtered}
            loadRowCount={data.length || 10}
            loading={isFetching}
          />
        </section>
      </PageWrapper>
    </InteractiveTable.Provider>
  );
}
